/* eslint-disable import/no-cycle */
import { RouteConfig } from 'vue-router';
import { IRouteConfigAuthMeta } from '@/shared';

const unitListAuth: IRouteConfigAuthMeta = {
  required: true,
  permissions: ['unit_list'],
};

const unitListBuilderIndex: RouteConfig = {
  path: '/unit-list-builder',
  name: 'UnitListIndex',
  component: () => import('@/views/settings/unit-list-builder/Index.vue'),
  meta: {
    auth: unitListAuth,
    title: 'Instances',
    icon: 'cogs',
    active: false,
    noPagePadding: true,
    parent: null,
  },
};

const fieldsBuilder: RouteConfig = {
  path: '/unit-list-builder/:ulbId/fields-builder',
  name: 'FieldsBuilder',
  component: () => import('@/views/settings/unit-list-builder/FieldsBuilder.vue'),
  meta: {
    auth: unitListAuth,
    title: 'Fields Builder',
    icon: 'cogs',
    active: false,
    noPagePadding: true,
    parent: unitListBuilderIndex,
    footerBar: {
      enabled: true,
      hasSave: true,
    },
  },
};

const summaryBuilder: RouteConfig = {
  path: '/unit-list-builder/:ulbId/summary-builder',
  name: 'SummaryBuilder',
  component: () => import('@/views/settings/unit-list-builder/SummaryBuilder.vue'),
  meta: {
    auth: unitListAuth,
    title: 'Summary Fields Builder',
    icon: 'cogs',
    active: false,
    noPagePadding: true,
    parent: unitListBuilderIndex,
    footerBar: {
      enabled: true,
      hasSave: true,
    },
  },
};

const filtersBuilder: RouteConfig = {
  path: '/unit-list-builder/:ulbId/filters-builder',
  name: 'FiltersBuilder',
  component: () => import('@/views/settings/unit-list-builder/FiltersBuilder.vue'),
  meta: {
    auth: unitListAuth,
    title: 'Filters Builder',
    icon: 'cogs',
    active: false,
    noPagePadding: true,
    parent: unitListBuilderIndex,
    footerBar: {
      enabled: true,
      hasSave: true,
    },
  },
};

const sortsBuilder: RouteConfig = {
  path: '/unit-list-builder/:ulbId/sorts-builder',
  name: 'SortsBuilder',
  component: () => import('@/views/settings/unit-list-builder/SortsBuilder.vue'),
  meta: {
    auth: unitListAuth,
    title: 'Sorts Builder',
    icon: 'cogs',
    active: false,
    noPagePadding: true,
    parent: unitListBuilderIndex,
    footerBar: {
      enabled: true,
      hasSave: true,
    },
  },
};

const formsBuilder: RouteConfig = {
  path: '/unit-list-builder/:ulbId/forms-builder',
  name: 'FormsBuilder',
  component: () => import('@/views/settings/unit-list-builder/FormsBuilder.vue'),
  meta: {
    auth: unitListAuth,
    title: 'Forms Builder',
    icon: 'cogs',
    active: false,
    noPagePadding: true,
    parent: unitListBuilderIndex,
    footerBar: {
      enabled: true,
      hasSave: true,
    },
  },
};

const tableSettings: RouteConfig = {
  path: '/unit-list-builder/:ulbId/settings',
  name: 'TableSettings',
  component: () => import('@/views/settings/unit-list-builder/Settings.vue'),
  meta: {
    auth: unitListAuth,
    title: 'Settings',
    icon: 'cogs',
    active: false,
    parent: unitListBuilderIndex,
    footerBar: {
      enabled: true,
      hasSave: true,
    },
  },
};

export default [
  unitListBuilderIndex,
  fieldsBuilder,
  summaryBuilder,
  filtersBuilder,
  sortsBuilder,
  formsBuilder,
  tableSettings,
] as Array<RouteConfig>;
